module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page-combinatie page",
    attrs: {
      "id": "page-combinatie"
    }
  }, [_c('div', {
    staticClass: "page__content"
  }, [_vm._m(0), _vm._v(" "), _c('h1', [_vm._v("BEKIJK VOORBEELDEN VAN DE URENVERDELING VAN HYBRIDE DOCENTEN")]), _vm._v(" "), _c('div', {
    staticClass: "container list-select"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.options), function(option) {
    return _c('div', {
      staticClass: "list-select__item row",
      class: {
        'list-select__item--selected': _vm.isSelected(option)
      },
      on: {
        "click": function($event) {
          _vm.selectTypeHandler(option)
        }
      }
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "col-10-sm list-select__item-text"
    }, [_vm._v("\n                    " + _vm._s(option.text) + "\n                ")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "double-bar-chart container"
  }, [_c('div', {
    staticClass: "row page-combinatie__sort-controls"
  }, [_c('div', {
    staticClass: "col-6-sm page-combinatie__sort-control",
    on: {
      "click": function($event) {
        _vm.doSort(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-numeric-desc",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" sorteer\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-6-sm page-combinatie__sort-control",
    on: {
      "click": function($event) {
        _vm.doSort(false)
      }
    }
  }, [_vm._v("\n                    sorteer "), _c('i', {
    staticClass: "fa fa-sort-numeric-desc",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _vm._l((_vm.filteredPersons), function(person) {
    return (_vm.selected.id === 'docent1') ? _c('div', {
      staticClass: "double-bar-chart__row"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-6-sm double-bar-chart__bar  double-bar-chart__bar--left double-bar-chart__bar--docent"
    }, [_c('div', {
      staticClass: "double-bar-chart__label"
    }, [_vm._v(_vm._s(_vm.getHours(person.uren_docent)))]), _vm._v(" "), _c('div', {
      staticClass: "double-bar-chart__graphic",
      style: (_vm.barWidth(person.uren_docent))
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-6-sm double-bar-chart__bar double-bar-chart__bar--right"
    }, [_c('div', {
      staticClass: "double-bar-chart__bar-plus"
    }), _vm._v(" "), _c('div', {
      staticClass: "double-bar-chart__graphic",
      style: (_vm.barWidth(person.uren_anders))
    }), _vm._v(" "), _c('div', {
      staticClass: "double-bar-chart__label"
    }, [_vm._v(_vm._s(_vm.getHours(person.uren_anders)))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-6-sm double-bar-chart__description double-bar-chart__description--docent double-bar-chart__description--left"
    }, [_vm._v(_vm._s(_vm.getJobDescription(person.baan_docent)))]), _vm._v(" "), _c('div', {
      staticClass: "col-6-sm double-bar-chart__description double-bar-chart__description--right"
    }, [_vm._v(_vm._s(_vm.getJobDescription(person.baan_anders)))])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.filteredPersons), function(person) {
    return (_vm.selected.id === 'docent2') ? _c('div', {
      staticClass: "double-bar-chart__row"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-6-sm double-bar-chart__bar  double-bar-chart__bar--left"
    }, [_c('div', {
      staticClass: "double-bar-chart__label"
    }, [_vm._v(_vm._s(_vm.getHours(person.uren_anders)))]), _vm._v(" "), _c('div', {
      staticClass: "double-bar-chart__graphic",
      style: (_vm.barWidth(person.uren_anders))
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-6-sm double-bar-chart__bar double-bar-chart__bar--right double-bar-chart__bar--docent"
    }, [_c('div', {
      staticClass: "double-bar-chart__bar-plus"
    }), _vm._v(" "), _c('div', {
      staticClass: "double-bar-chart__graphic",
      style: (_vm.barWidth(person.uren_docent))
    }), _vm._v(" "), _c('div', {
      staticClass: "double-bar-chart__label"
    }, [_vm._v(_vm._s(_vm.getHours(person.uren_docent)))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-6-sm double-bar-chart__description double-bar-chart__description--left"
    }, [_vm._v(_vm._s(_vm.getJobDescription(person.baan_anders)))]), _vm._v(" "), _c('div', {
      staticClass: "col-6-sm double-bar-chart__description double-bar-chart__description--docent double-bar-chart__description--right"
    }, [_vm._v(_vm._s(_vm.getJobDescription(person.baan_docent)))])])]) : _vm._e()
  })], 2), _vm._v(" "), _c('page-next-button', {
    on: {
      "click": _vm.nextHandler
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page__icon-wrapper"
  }, [_c('i', {
    staticClass: "far fa-clock"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-10 list-select__title"
  }, [_vm._v("Hoeveel uren besteden hybride docenten per week "), _c('br'), _vm._v("aan hun banen als ze:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-2-sm list-select__item-marker-column"
  }, [_c('div', {
    staticClass: "list-select__item-marker"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d38de4ca","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/page-combinatie.vue
// module id = 155
// module chunks = 0